module.exports = __webpack_public_path__ + "media/images/pengurus/komisaris-f26978ae8f86677b360299fe1dd710eb.jpeg";